// @flow

import * as React from 'react';

import { compose } from 'redux';

import { withForm } from 'gandi.react-form';

import AuthInfoForm from './AuthInfoForm';
import type { AuthInfoFormProps } from './AuthInfoForm';
import formValidation from './validation';

export default (compose(
  withForm<React.ComponentType<AuthInfoFormProps>>({
    form: AuthInfoForm.FORM_ID,
    validate: formValidation,
  }),
)(AuthInfoForm): React.ComponentType<AuthInfoFormProps>);
